(() => {
  const sliders = new Map();
  const desktopQuery = window.matchMedia('(min-width: 1000px)');

  const getSlideCount = (sliderElement) =>
    sliderElement.querySelectorAll('.splide__slide').length;

  const syncDots = (slideElement, activeIndex) => {
    slideElement.querySelectorAll('.shop-the-look__dot').forEach((dot) => {
      const index = Number(dot.dataset.productIndex);
      dot.classList.toggle('is-active', index === activeIndex);
    });
  };

  const syncViewButton = (panel, activeIndex) => {
    const button = panel.querySelector('[data-stl-view-button]');
    const slides = panel.querySelectorAll('.shop-the-look__products .splide__slide');
    const activeSlide = slides[activeIndex];
    if (!button || !activeSlide) return;
    button.href = activeSlide.dataset.productUrl || '#';
  };

  const mountProductSlider = (panel, slideElement) => {
    if (!window.Splide || sliders.has(panel)) return;

    const sliderElement = panel.querySelector('.shop-the-look__products');
    if (!sliderElement) return;

    const slideCount = getSlideCount(sliderElement);
    const splide = new Splide(sliderElement, {
      type: 'fade',
      rewind: slideCount > 1,
      perPage: 1,
      perMove: 1,
      arrows: false,
      pagination: slideCount > 1,
      speed: 550,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      drag: false,
      keyboard: 'focused',
    });

    splide.on('move', (newIndex) => {
      syncDots(slideElement, newIndex);
      syncViewButton(panel, newIndex);
    });

    splide.mount();
    sliders.set(panel, splide);
  };

  const mountPopoverSlider = (popover) => {
    if (!window.Splide || sliders.has(popover)) return;

    const sliderElement = popover.querySelector('.shop-the-look__popover-products');
    if (!sliderElement || sliderElement.classList.contains('is-initialized')) return;

    const slideCount = getSlideCount(sliderElement);
    const splide = new Splide(sliderElement, {
      type: 'slide',
      rewind: slideCount > 1,
      perPage: 1,
      perMove: 1,
      arrows: false,
      pagination: false,
      speed: 550,
      drag: slideCount > 1,
      flickPowerThreshold: 10,
      keyboard: 'focused',
    });

    splide.mount();
    sliders.set(popover, splide);
  };

  const mountMainSlider = (section) => {
    const sliderElement = section.querySelector('.shop-the-look__main');
    if (!window.Splide || !sliderElement || sliders.has(sliderElement)) return;

    const lookCount = Number(section.dataset.lookCount) || getSlideCount(sliderElement);
    const isDesktop = desktopQuery.matches;

    const splide = new Splide(sliderElement, {
      type: 'slide',
      rewind: isDesktop && lookCount > 1,
      perPage: 1,
      perMove: 1,
      focus: 'center',
      trimSpace: true,
      arrows: isDesktop && lookCount > 1,
      arrowPath: '',
      pagination: false,
      speed: 750,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      drag: !isDesktop && lookCount > 1,
      flickPowerThreshold: 10,
      keyboard: 'focused',
      breakpoints: {
        999: {
          autoWidth: true,
          arrows: false,
          drag: lookCount > 1,
          rewind: false,
          focus: 'center',
          trimSpace: false,
          padding: 0,
          gap: '10px',
        },
      },
    });

    splide.on('move', (index) => {
      section.dataset.activeLookIndex = String(index);
    });

    splide.mount();
    sliders.set(sliderElement, splide);
  };

  const destroyAll = (section) => {
    const sectionKey = section.dataset.sectionId || section.id;
    const keys = [
      section.querySelector('.shop-the-look__main'),
      ...section.querySelectorAll('.shop-the-look__product-panel'),
      ...document.querySelectorAll(`[data-stl-popover][data-stl-section="${sectionKey}"]`),
    ].filter(Boolean);

    keys.forEach((key) => {
      const splide = sliders.get(key);
      if (!splide) return;
      splide.destroy(true);
      sliders.delete(key);
    });
  };

  const getSectionKey = (section) => section.dataset.sectionId || section.id;

  /**
   * `.reveal-on-scroll` applies a transform, which makes it a containing block
   * for `position: fixed` children. The popovers must live on <body> to anchor
   * to the viewport.
   */
  const relocatePopovers = (section) => {
    const key = getSectionKey(section);

    section.querySelectorAll('[data-stl-popover]').forEach((popover) => {
      popover.dataset.stlSection = key;
      document.body.appendChild(popover);
    });

    let backdrop = document.querySelector(`[data-stl-backdrop="${key}"]`);
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'shop-the-look__popover-backdrop';
      backdrop.dataset.stlBackdrop = key;
      document.body.appendChild(backdrop);
    }

    return backdrop;
  };

  const getPopovers = (section) =>
    document.querySelectorAll(`[data-stl-popover][data-stl-section="${getSectionKey(section)}"]`);

  const openPopover = (section, lookIndex, productIndex) => {
    const key = getSectionKey(section);
    const popover = document.querySelector(
      `[data-stl-popover][data-stl-section="${key}"][data-look-index="${lookIndex}"]`
    );
    if (!popover) return;

    mountPopoverSlider(popover);

    const splide = sliders.get(popover);
    if (splide && productIndex > 0) splide.go(productIndex);

    popover.classList.add('is-open');
    popover.setAttribute('aria-hidden', 'false');

    const backdrop = document.querySelector(`[data-stl-backdrop="${key}"]`);
    if (backdrop) backdrop.classList.add('is-open');

    const openBtn = section.querySelector('[data-stl-open-popover]');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
  };

  const bindDots = (section, slideElement, lookIndex) => {
    slideElement.querySelectorAll('.shop-the-look__dot').forEach((dot) => {
      if (dot.dataset.stlDotReady) return;
      dot.dataset.stlDotReady = 'true';

      dot.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const productIndex = Number(dot.dataset.productIndex) || 0;
        syncDots(slideElement, productIndex);

        if (desktopQuery.matches) {
          const panel = slideElement.querySelector('.shop-the-look__product-panel');
          const splide = panel && sliders.get(panel);
          if (splide) splide.go(productIndex);
          return;
        }

        openPopover(section, lookIndex, productIndex);
      });
    });
  };

  const initPopover = (section, backdrop) => {
    const closePopovers = () => {
      getPopovers(section).forEach((popover) => {
        popover.classList.remove('is-open');
        popover.setAttribute('aria-hidden', 'true');
      });
      backdrop.classList.remove('is-open');
      const openBtn = section.querySelector('[data-stl-open-popover]');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    };

    getPopovers(section).forEach((popover) => {
      popover.querySelectorAll('[data-stl-popover-close]').forEach((button) => {
        if (button.dataset.stlCloseReady) return;
        button.dataset.stlCloseReady = 'true';
        button.addEventListener('click', closePopovers);
      });
    });

    if (!backdrop.dataset.stlBackdropReady) {
      backdrop.dataset.stlBackdropReady = 'true';
      backdrop.addEventListener('click', closePopovers);
    }

    const openBtn = section.querySelector('[data-stl-open-popover]');
    if (openBtn && !openBtn.dataset.stlOpenReady) {
      openBtn.dataset.stlOpenReady = 'true';
      openBtn.addEventListener('click', () => {
        const activeIndex = Number(section.dataset.activeLookIndex) || 0;
        openPopover(section, activeIndex, 0);
      });
    }
  };

  const initSection = (section) => {
    destroyAll(section);
    section.dataset.activeLookIndex = '0';
    mountMainSlider(section);

    const backdrop = relocatePopovers(section);
    getPopovers(section).forEach(mountPopoverSlider);
    initPopover(section, backdrop);

    section.querySelectorAll('.shop-the-look__slide').forEach((slideElement, lookIndex) => {
      const panel = slideElement.querySelector('.shop-the-look__product-panel');
      if (panel && desktopQuery.matches) mountProductSlider(panel, slideElement);
      bindDots(section, slideElement, lookIndex);
    });
  };

  const syncDesktop = () => {
    document.querySelectorAll('[data-shop-the-look]').forEach((section) => {
      destroyAll(section);
      initSection(section);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-shop-the-look]').forEach(initSection);
  });

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-shop-the-look]').forEach(initSection);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-shop-the-look]').forEach((section) => {
      destroyAll(section);

      const key = getSectionKey(section);
      document
        .querySelectorAll(`[data-stl-popover][data-stl-section="${key}"], [data-stl-backdrop="${key}"]`)
        .forEach((element) => element.remove());
    });
  });

  desktopQuery.addEventListener('change', syncDesktop);
})();
